const routes = {
	'/cardcoupon-promotion': '卡券促销',
};

export {
	routes,
};
